export default "__VITE_ASSET__D0pPu2eN__"